// Styling classes for variants
export const variantClasses = {
  light: 'border-neutral-100 bg-white text-brand-700 active:border-brand-700',
  dark: 'border-neutral-100 bg-white text-brand-700 active:border-brand-700',
};

// Styling classes for input sizes
export const sizeClasses = {
  small: 'text-sm py-1 px-2',
  medium: 'text-base py-2 px-3',
  large: 'text-lg py-3 px-4',
};

// Error state class
export const errorClasses = 'border-red-100 bg-red-0 text-red-200';

// Disabled state class
export const disabledClasses = 'bg-neutral-0 cursor-not-allowed';

// Valid state class
export const validClasses =
  'border-green-300 bg-green-0 text-green-300 font-normal';

// Basic class
export const baseClasses =
  'block border rounded focus:outline-none focus:border-brand-700';
